<template>
  <div>
    <el-row>
      <el-col style="margin-top:18px" :span="6">
        <el-button v-preventReClick size="medium" @click="submitPrice" type="primary" :disabled="isDisabled">提交
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" stripe
          border :data="newTableData" style="margin-top: 20px">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="二级大类" prop="SCNAME"></el-table-column>
          <el-table-column label="编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="名称" prop="NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="需求量" prop="PRODUCT_COUNT"></el-table-column>
          <!-- <el-table-column label="报价" >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.SUBMIT_PRICE" :disabled="isDisabled"></el-input>
                        </template>
                    </el-table-column> -->
          <el-table-column label="报价">
            <template slot-scope="scope">
              <el-input style="width: 60%" v-model='scope.row.SUBMIT_PRICE' @change="setPrice(scope.row)"
                :readonly="isDisabled" :disabled="isDisabled" clearable oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                ></el-input>
              <span>元</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="DESC">
            <template slot-scope="scope">
              <el-input style="width: 60%" v-model='scope.row.DESC' :readonly="isDisabled" :disabled="isDisabled" clearable></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button v-preventReClick type="text" @click="submitPrice(scope.row)" :disabled="isDisabled">提交</el-button>
                        </template>
                    </el-table-column> -->
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-pagination @size-change="sizeChange" :current-page="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalCount" @current-change="handleCurrentChange"
        style="float:right">
      </el-pagination>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      tableData: [],
      newTableData: [],
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      priceStatus: 0,
      isDisabled: false,
      loading: true,
      SUBMIT_PRICE: [],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
    this.priceStatus = Number(sessionStorage.getItem('priceStatus'));
    if (this.priceStatus === 1) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  },
  methods: {
    queryTable() { // index
      const params = {
        SERVICE_ID: '10070',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        // RECORD_ID: sessionStorage.getItem('recordId'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        COMPARE_ID: sessionStorage.getItem('COMPARE_ID'),
        F_CAT_ID: sessionStorage.getItem('F_CAT_ID'),
        // PAGEINDEX: this.pageSize,
        // PAGESIZE: this.currentPage - 1,
      };
      http.post(params).then((result) => {
        if (result) {
          // console.log(result)
          this.tableData = result[0].PRODUCT_INFO;
          this.totalCount = this.tableData.length;
          if (sessionStorage.getItem('SUBMIT_PRICE')) {
            this.tableData = JSON.parse(sessionStorage.getItem('SUBMIT_PRICE'));
            // console.log(this.SUBMIT_PRICE);
            console.log(this.tableData, '第二次');
          }
          this.newTableData = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
        this.loading = false;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    setPrice(row) {
      sessionStorage.setItem('SUBMIT_PRICE', JSON.stringify(this.tableData));
      console.log(this.tableData, '存储数据');
    },
    submitPrice(row) {
      const params = {
        SERVICE_ID: '10070',
        OTYPE: 4,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
      };
      const product_data = [];
      for (let i = 0; i < this.tableData.length; i++) {
        const price = Number(this.tableData[i].SUBMIT_PRICE);
        if (!validation.价格正数0验证(this.tableData[i].SUBMIT_PRICE) || price > 999999) {
          this.$message.show({ text: '请输入0-999999之间合适的价格', type: 'warning' });
          return;
        }
        const data = {
          DETAIL_ID: this.tableData[i].DETAIL_ID,
          SUBMIT_PRICE: price,
          DESC: this.tableData[i].DESC,
        };
        product_data.push(data);
      }
      params.PRODUCT_DATA = product_data;
      console.log(params.PRODUCT_DATA);
      http.post(params).then((result) => {
        this.$message.show({
          text: '提交成功',
          type: 'success',
        });
        delete sessionStorage.SUBMIT_PRICE;
        this.$router.push({ path: '/quote' });
        sessionStorage.setItem('activeName', 'supplier');
      })
        .catch((error) => {
          this.$message.show({
            text: error,
            type: 'error',
          });
        });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    // size改变时回调函数，参数为当前size
    sizeChange(e) {
      console.log('改变每页多少条，当前每页多少条数据', e);
      this.pageSize = e;
      this.currentPage = 1;
      this.queryTable();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/checkProductPrice.vue